import type { Board } from './PluginHeaderButton.types';
import { usePluginData } from './usePluginData';

export const useHasDeprecatedPlugins = (board: Board) => {
  const { isLoading, error, pluginsData } = usePluginData(board);

  if (isLoading || error) {
    return false;
  }

  return (
    pluginsData?.plugins.some(
      (plugin) => plugin.attributes.deprecation?.sunsetDate,
    ) ?? false
  );
};
